<template>
  <BaseModal modal-content-class="bonus_modal midnight">
    <div class="content">
      <BaseImage
        src="/static/images/modals/notifications/new_friend_icon.svg"
        alt="Invite Friend"
      />

      <h2>{{ $_translations.value.modal_success_invite_title }}</h2>

      <div class="bonus_time">
        <p>
          {{ $_translations.value.modal_success_invite_description_pt1 }}
          <span class="yellow_bold">{{ friendName }}</span>
          {{ $_translations.value.modal_success_invite_description_pt2 }}
        </p>
      </div>

      <RewardBoxItem
        :prize-value="prizeValue"
        :prize-type="prizeType"
      />

      <BaseButton button-class="fancy_btn close_modal">
        {{ $_translations.value.modal_success_invite_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>
<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import RewardBoxItem from '@/components/item/RewardBoxItem.vue';
import BaseButton from '@/components/button/BaseButton.vue';

defineProps({
  prizeValue: {
    type: Number,
    default: 0,
  },
  prizeType: {
    type: String,
    default: '',
  },
  friendName: {
    type: String,
    default: '',
  },
});
</script>
